import React from 'react';
import AnalysisTextSection from './AnalysisTextSection';
import { Registry } from '@/graphql/__generated__/onboarding-legal';
import { useNormalizedAntifraudData } from '@/hooks/useNormalizedAntifraudData';

interface RfcProps {
	registry: Registry;
}

export const Rfc: React.FC<RfcProps> = ({ registry }) => {
	const normalizedData = useNormalizedAntifraudData(registry);

	return (
		<div className="space-y-3">
			<AnalysisTextSection label="BlacklistStatus" value={normalizedData?.rfc?.blacklistStatus} />
			<AnalysisTextSection label="IsValid" value={normalizedData?.rfc?.isValid} />
			<AnalysisTextSection label="Observation" value={normalizedData?.rfc?.observation} />
			<AnalysisTextSection label="ValidatedRfc" value={normalizedData?.rfc?.validatedRfc} />
		</div>
	);
};

export default Rfc;
